import EventScope from 'owa-service/lib/contract/EventScope';
import { useParams } from 'react-router-dom';

export const SCOPE_PARAM = 'scope';

/**
 * A hook which converts a scope from the route params to an Event scope object
 */
export const useEventScopeFromRoute = (): EventScope => {
    const params = useParams();
    const scope = params[SCOPE_PARAM];
    return isNaN(scope) ? EventScope.Default : parseInt(scope);
};
